
<template>
    <div class="">

      

        <div>
            <div class="row justify-content-center justify-content-lg-start mt-5">
                <p class="h1">{{overallData.organization.name}}</p>
            </div>

            <div ref="reviewDropDrown" @click = "(showUserLocationLoader) ? reviewDropDrown=true : reviewDropDrown=!reviewDropDrown" style= "cursor: pointer;" class="row justify-content-center justify-content-lg-start mt-3">
                <!-- 1 -->
                <div class = "reviewStarHolder">
                     <div :class="ol = (overallData.organization.overall_pct.toFixed(2)*5).toFixed(1)"></div>

                    <div class="reviewiconborder mr-1 ml-2 st1" style="position:relative;">
                        <div :class="{reviewhalficonfill:(ol >= 0.5) ? true : false, reviewiconfill:(ol >= 1) ? true : false }"></div>
                    </div>
                    <div class="reviewiconborder mr-1 st2" style="position:relative;">
                        <div :class="{reviewhalficonfill:(ol >= 1.5) ? true : false, reviewiconfill:(ol >= 2) ? true : false }"></div>
                    </div>
                    <div class="reviewiconborder mr-1 st3" style="position:relative;">
                        <div :class="{reviewhalficonfill:(ol >= 2.5) ? true : false, reviewiconfill:(ol >= 3) ? true : false }"></div>
                    </div>
                    <div class="reviewiconborder mr-1 st4" style="position:relative;">
                        <div :class="{reviewhalficonfill:(ol >= 3.5) ? true : false, reviewiconfill:(ol >= 4) ? true : false }"></div>
                    </div>
                    <div class="reviewiconborder mr-1 st5" style="position:relative;">
                        <div :class="{reviewhalficonfill:(ol >= 4.5) ? true : false, reviewiconfill:(ol >= 5) ? true : false }"></div>
                    </div>

                    <!-- Reiew Drop Down -->
                    <div :class = "{displayNot:reviewDropDrown}" class="flex-column text-center dropdownreviews">
                        
                        <div class="p-2 small my-2"><span class="font-weight-bold">{{(overallData.organization.overall_pct.toFixed(2)*5).toFixed(1)}}</span> out of <span class="font-weight-bold">5.0</span> Stars</div>
                        
                        <div @click.stop.prevent = "reviewSelected('5 Stars'); reviewDropDrown=!reviewDropDrown" class="reviewhover pb-2" ><span class="small eachstartitlepadding color1">5 Stars</span>
                                <span class = "d-inline-block ">
                                    <div class="reviewiconborderdark eachstarcolor1outline mr-1 ml-sm-2">
                                        <div class="reviewiconfilldark eachstarcolor1fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor1outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor1fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor1outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor1fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor1outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor1fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor1outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor1fill"></div>
                                    </div>
                                </span>
                        </div>

                        <div @click.stop.prevent = "reviewSelected('4 Stars'); reviewDropDrown=!reviewDropDrown" class="reviewhover pb-2"><span class="small eachstartitlepadding color1">4 Stars</span>
                                <span class = "d-inline-block" >
                                    <div class="reviewiconborderdark eachstarcolor2outline mr-1 ml-sm-2">
                                        <div class="reviewiconfilldark eachstarcolor2fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor2outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor2fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor2outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor2fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor2outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor2fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor2outline mr-1">
                                    </div>
                                </span>
                        </div>

                        <div @click.stop.prevent = "reviewSelected('3 Stars'); reviewDropDrown=!reviewDropDrown" class="reviewhover pb-2"><span class="small eachstartitlepadding color1">3 Stars</span>
                                <span class = "d-inline-block" >
                                    <div class="reviewiconborderdark eachstarcolor3outline mr-1 ml-sm-2">
                                        <div class="reviewiconfilldark eachstarcolor3fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor3outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor3fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor3outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor3fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor3outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor3outline mr-1">
                                    </div>
                                </span>
                        </div>

                        <div @click.stop.prevent = "reviewSelected('2 Stars'); reviewDropDrown=!reviewDropDrown" class="reviewhover pb-2"><span class="small eachstartitlepadding color1">2 Stars</span>
                                <span class = "d-inline-block" >
                                    <div class="reviewiconborderdark eachstarcolor4outline mr-1 ml-sm-2">
                                        <div class="reviewiconfilldark eachstarcolor4fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor4outline mr-1">
                                        <div class="reviewiconfilldark eachstarcolor4fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor4outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor4outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor4outline mr-1">
                                    </div>
                                </span>
                        </div>

                        <div @click.stop.prevent = "reviewSelected('1 Star'); reviewDropDrown=!reviewDropDrown" class="reviewhover pb-2 mb-3"><span class="small eachstartitlepadding color1">1 Stars</span>
                                <span class = "d-inline-block" >
                                    <div class="reviewiconborderdark eachstarcolor5outline mr-1 ml-sm-2">
                                        <div class="reviewiconfilldark eachstarcolor5fill"></div>
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor5outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor5outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor5outline mr-1">
                                    </div>
                                    <div class="reviewiconborderdark eachstarcolor5outline mr-1">
                                    </div>
                                </span>
                        </div>


                    </div>

                </div>
                
                <!-- 2 -->
                <!-- <img class="droparrow" src="./assets/loupe_down_arrow.svg" alt="drop arrow"> -->
                <img class="droparrow" src="builds/l_down_arrow.svg" alt="drop arrow">


                <!-- 3 -->
                <span class="reviewstext">
                    <p class="p-0 m-0 ml-2 color1"><small>{{overallData.organization.total_surveys.toLocaleString()}} Reviews</small></p>
                </span>

            </div>


            <div :style="{ visibility: (showUserLocationLoader) ? 'hidden': 'visible' }" class="row justify-content-center justify-content-lg-start mt-4">
                <div ref="openStoreDropDown" @click = "selectastore" class="blockbtn p-3" style="position:relative;">
                <img class="" style="float:left; position:relative; top:2px; left:220px; pointer-events:none; width:16px; height:14px; " src="builds/l_down_arrow.svg" alt="drop arrow">
                    <p class="p-1 m-0 pr-5">{{storeSelected.name}}, {{storeSelected.state}}</p>
                    
                        <div :class = "{ displayNot: openStoreDropDown}" class = "dropdownfilterstores py-2">
                            <a @click.stop.prevent = "storeselected(val)" v-for = "(val, key, index) in overallData.stores" class="d-block py-3 px-2 color2" :href = "val.name" :lid = "val.loupeid">
                                {{val.name}}, {{val.state}}
                            </a>
                        </div>

                </div>
            </div>

            <div class="text-center text-lg-left" v-if= "showUserLocationLoader">
                <pulse-loader :color= "{color:'#9a9c9f'}.color" :size= "{size:'10px'}.size"></pulse-loader>
                <p class="h6 color2">Please Wait..</p>
            </div>


            <div :style="{ visibility: (showUserLocationLoader) ? 'hidden': 'visible' }" class="row justify-content-center justify-content-lg-start mt-4">
                <!-- <img class="" src="./assets/map.jpg" alt="map"> -->
                <div :class = "{ displayNot: !gApiLoaded }" id="gmapstore" ref="gmapstore" style="width:270px; height:100px; border-radius:17px;"></div>
            </div>

            <div :style="{ visibility: (showUserLocationLoader) ? 'hidden': 'visible' }" class="addresstext mt-4">
                <p class="color1 text-center text-lg-left">{{storeSelected.address1}} {{storeSelected.address2}}</p>
                <p class="color1 text-center text-lg-left">{{storeSelected.city}}, {{storeSelected.state}} {{storeSelected.zip}}</p>
                <p class="color1 text-center text-lg-left">{{formatPhoneNumber(storeSelected.phone)}}</p>
                <a :href = "storeSelected.url" style="text-decoration:none;"><p class="color3 text-center text-lg-left">{{storeSelected.url}}</p></a>
            </div>


            <div :style="{ visibility: (showUserLocationLoader) ? 'hidden': 'visible' }" class="text-center text-lg-left  mt-5">
                <a href="http://www.apexenergygroup.com"><button class="blockbtn darkbtn "><p class="h4 m-0">Request More Info</p></button></a>
            </div>

        </div>

    </div>
</template>





<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import gIconImg from './assets/gmapicon.png';
import {style} from './gmapstyle.js';
import {apiURLBase} from './constants.js';





export default {
    name:'store-selection',
    props: ['overallData','gApiLoaded'],
    data: function (){
        return {
            title:"Apex Energy Solutions",
            storeSelected:{},
            openStoreDropDown:true,
            reviewDropDrown:true,
            showUserLocationLoader:true,
    }
    },
    components : {
        PulseLoader,
    },
    methods: {

        startAnimation: function(){

            var tl = new TimelineMax();
            tl.set(".reviewiconborder",{scale:1, opacity:0})
            .staggerTo(".reviewiconborder",0.4, {delay:1.5, scale:1.4, x:"+=10" , opacity:0.8,  borderColor:"#54d76a", ease:Power1.easeInOut},0.2)
            .add(TweenMax.staggerTo(".reviewiconborder",0.4, {scale:1.6, x:"-=20",  opacity:0.8,  borderColor:"#b8f768", ease:Power1.easeOut},0.2), "-=0.85")
            .add(TweenMax.staggerTo(".reviewiconborder",0.3, {scale:1, opacity:1, x:0, borderColor:"#54d76a", ease:Power1.easeInOut},0.2), "-=1")
            .fromTo(".droparrow", 0.3, {y:"-5", opacity:0}, {y:0, opacity:1, ease:Power1.easeInOut})
            .fromTo(".reviewstext", 0.8, {x:"-10", opacity:0}, {x:0, opacity:1, ease:Power1.easeInOut});
            
            tl.play();


            this.particleStartAnimation();

        },

        particleStartAnimation: function (){

                function eachParticleEffect(addUnder, nbOfParticles, duration) {

                    var dots = new TimelineMax(),  
                        qty = nbOfParticles,
                        
                        colors = ["#b8f768","#5ada85","#ffe400","#979797","#00ff2a"];

                    for (var i = 0; i < qty; i++) {
                        var dot = $("<div class='dot'/>").prependTo(addUnder)[0];
                        var color = colors[(Math.random() * colors.length) | 0];
                        
                        TweenMax.set(dot, {backgroundColor:color, x:5, y:Math.random()*13+2, scale:Math.random()*0.6+0.2});//
                        
                        var delay = Math.random() * 0.2;
                        dots.to(dot, duration, {opacity:0,  backgroundColor:"#00ff2a",  physics2D:{velocity:Math.random() * 100 + 140, angle:Math.random()*360, gravity:300}}, delay);
                        dots.addCallback(function(){ addUnder.find(".dot").remove();});
                    }
                    // dots.pause();
                    return dots;
    
                }

                var playParticle = new TimelineMax();
                
                playParticle.add(eachParticleEffect($(".st1"),20,0.8), "+=1.7");
                playParticle.add(eachParticleEffect($(".st2"),20,0.8), "-=0.8");
                playParticle.add(eachParticleEffect($(".st3"),20,0.8), "-=0.7");
                playParticle.add(eachParticleEffect($(".st4"),20,0.8), "-=0.7");
                playParticle.add(eachParticleEffect($(".st5"),60,5), "-=0.8");
                playParticle.addCallback(function(){$(".reviewStarHolder").find(".dot").remove();});
                

        },



        selectastore : function (){
  
            this.openStoreDropDown = !this.openStoreDropDown;
        },
        storeselected : function(val){
          
            this.storeSelected = val;
            this.selectastore();

            this.$emit('storeissselected', this.storeSelected);

             this.addUpdateGMap();
        },
        reviewSelected: function(starParam){
                        
            this.$emit('reviewisselected', starParam);

        },
        formatPhoneNumber: function(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            return (!match) ? null : "(" + match[1] + ") " + match[2] + "-" + match[3];
        },

        findClosestsLocationToUserLocation: function(coords){
            var userLng = coords.longitude;
            var userLat = coords.latitude;
            
            localStorage.setItem('userLng',userLng);
            localStorage.setItem('userLat',userLat);
            if (apiURLBase == "loupedev"){
                console.log('User longitude', userLng , 'User latitude', userLat);
            }

            function haversineDistance(coords1, coords2, isMiles) {
                function toRad(x) {
                    return x * Math.PI / 180;
                }

                var lon1 = coords1[0];
                var lat1 = coords1[1];

                var lon2 = coords2[0];
                var lat2 = coords2[1];

                var R = 6371; // km

                var x1 = lat2 - lat1;
                var dLat = toRad(x1);
                var x2 = lon2 - lon1;
                var dLon = toRad(x2)
                var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;

                if(isMiles) d /= 1.60934;

                return d;
            }
            

            //Loop thru all the stores and find the distance of each to the user's location.
            var storesWithDistance = this.overallData.stores.map (function(eachStore){
                    var distance = haversineDistance([userLng, userLat] , [eachStore.lon, eachStore.lat] , true);
                    eachStore.distance = distance;
                    return eachStore;
            });
            
            this.overallData.stores = storesWithDistance;

            //Find the lowest distance.
            var closestStore = storesWithDistance.reduce(function(prev, curr) {
                return prev.distance < curr.distance ? prev : curr;
            });
if (apiURLBase == "loupedev"){
            console.log("closest store is", closestStore);
}
            this.storeSelected = closestStore; 

            this.$emit('storeissselected', this.storeSelected);


            this.addUpdateGMap();

        },
        addUpdateGMap: function (){
if (apiURLBase == "loupedev"){
            console.log("gApiLoaded", this.gApiLoaded);
}
            if (this.gApiLoaded){

                var latlng = new google.maps.LatLng(this.storeSelected.lat, this.storeSelected.lon);

                // console.log("gMapStylJSON",gMapStylJSON);

                var map = new google.maps.Map(document.getElementById('gmapstore'), {
                    center: latlng,
                    zoom: 15,
                    disableDefaultUI: true,
                    styles: style,
                });

                
                // var marker = new google.maps.Marker({
                //     position: latlng,
                //     title:"Hello World!"
                // });

                // marker.setMap(map);

                var beachMarker = new google.maps.Marker({
                    position: {lat: this.storeSelected.lat, lng: this.storeSelected.lon},
                    map: map,
                    icon: gIconImg
                });
      
                google.maps.event.addListener(beachMarker,'click',function() {
                    window.open("http://maps.google.com/maps?daddr="+latlng+"&ll=");
                });

                // console.log(document.getElementById('gmapstore'));
                // console.log(this.$refs.gmapstore);

            }


        },
        documentClick(e){

            //this.startAnimation();

            var reviewDropDrown = this.$refs.reviewDropDrown;
            var openStoreDropDown = this.$refs.openStoreDropDown;

            var target = e.target
            

            if(!reviewDropDrown.contains(target)){
                if (!this.reviewDropDrown) {
                 this.reviewDropDrown = true;
                }
            }
            if(!openStoreDropDown.contains(target)){
                if (!this.openStoreDropDown) {
                 this.openStoreDropDown = true;
                }
            }

        }
    },
    created : function(){
        document.addEventListener('click', this.documentClick);
       

    },
    destroyed () {
        document.removeEventListener('click', this.documentClick)
    },
    mounted :function (){
            
        

        const self = this;

        this.startAnimation();
        
        



       // this.findClosestsLocationToUserLocation({longitude: -86.2443093, latitude:  39.95666550000001})

        // setTimeout(function(){
        //     self.showUserLocationLoader = false;
        //     self.findClosestsLocationToUserLocation({longitude: -86.2443093, latitude:  39.95666550000001})
        // },5000);

        // return;

        var userLng = localStorage.getItem('userLng');
        var userLat = localStorage.getItem('userLat');
        if (apiURLBase == "loupedev"){
            console.log("Local storage (lng, lat): ", userLng, userLat);
        }

        //Alreay have the user location saved
        if (userLng != null && userLat != null) {
            // ##### Hide the ui loader
           self.showUserLocationLoader = false;
           self.findClosestsLocationToUserLocation({longitude: userLng, latitude:  userLat});
           return;
        }

        if ("geolocation" in navigator) {

            // Check if geolocation is supported/enabled on current browser
            navigator.geolocation.getCurrentPosition(

                function success(position) {
                    // for when getting location is a success
                    // ##### Hide the ui loader
                    self.showUserLocationLoader = false;
                    
                    self.findClosestsLocationToUserLocation(position.coords)
                },
                function error(error_message) {
                    // ##### Hide the ui loader
                    self.showUserLocationLoader = false;


                    // for when getting location results in an error
                    console.error('An error has occured while retrieving location', error_message)

                    self.storeSelected = self.overallData.stores[0];
                    self.$emit('storeissselected', self.storeSelected);
                    self.addUpdateGMap();
                },
                {
                    enableHighAccuracy: true,
                    timeout: 20000,
                    maximumAge: 0
                }
            );

        }
        else {
            // geolocation is not supported
            // get your location some other way
            self.showUserLocationLoader = false;

            console.log('Geolocation is not enabled on this browser')
            self.storeSelected = self.overallData.stores[0];
            self.$emit('storeissselected', self.storeSelected);
            self.addUpdateGMap();
        }
 

        

        //Animate the stars in
        


        




    }

}




</script>






<style>
/* .svg1{
  background-image: url("./assets/loupe_down_arrow.svg");
} */

.reviewStarHolder{
    position:relative;
}

.dot {
  position:absolute;
  background-color: #91e600;
  width:5px;
  height:5px;
  border-radius:50%;
}

.reviewhover{
    opacity:0.7;
}
.reviewhover:hover{
    opacity:1.0;
}

.dropdownfilterstores{
    position:absolute;
    left:0px;
    top:50px;
    width:270px;
    border-radius: 25px;
    background-color: #cfd1d4;
    z-index:1;
    height:430px;
    overflow:auto;
}


.dropdownfilterstores a:hover{
    color: #13151b;
    text-decoration: none;
}



.eachstarcolor1outline{
    border-color: #54d76a !important;
}
.eachstarcolor1fill{
    background-color: #54d76a !important;
}
.eachstarcolor2outline{
    border-color: #9fff17 !important;
}
.eachstarcolor2fill{
    background-color: #9fff17 !important;
}
.eachstarcolor3outline{
    border-color: #ffe400 !important;
}
.eachstarcolor3fill{
    background-color: #ffe400 !important;
}
.eachstarcolor4outline{
    border-color: #ff8a00 !important;
}
.eachstarcolor4fill{
    background-color: #ff8a00 !important;
}
.eachstarcolor5outline{
    border-color: #ff0000 !important;
}
.eachstarcolor5fill{
    background-color: #ff0000 !important;
}




.dropdownreviews{
    position:absolute;
    top:35px;
    width:230px;
    border-radius: 25px;
    background-color: #f1f1f2;
    border: 1px solid #e2e2e2;
    z-index:3;
    box-shadow: 2px 3px 10px grey;
}

.eachstartitlepadding{
    position:relative;
    top:-5px;
}

.darkbtn{
    background-color: #c5c6c7;
    width:220px;
}
.darkbtn:hover{
    background-color: #b6b8b9;
}

.addresstext p {
    margin:0;
   
    
}

.reviewstext{
    margin-bottom:6px;

}

.droparrow{
    margin:5px 15px 0px 10px;
    width:15px;
    height:14px;
    /* background-color: aqua; */
}
.reviewiconborder{
    border: 3px solid #54d76a;
    border-radius: 50%;
	width: 30px;
    height: 30px; 
    display:inline-block;
}

.reviewhalficonfill{
     /* setting these to absolute so that it's over the particle dots */
    position: absolute; 
    border-radius: 20px 0 0 20px;
     margin:2px;
	width: 10px;
    height: 20px; 
     background-color: #54d76a;
  
}
.reviewiconfill{
    /* setting these to absolute so that it's over the particle dots */
    position: absolute; 
    border-radius: 50%;
    margin:2px;
	width: 20px;
    height: 20px; 
    background-color: #54d76a;
  
}



</style>



// WEBPACK FOOTER //
// StoreSelection.vue?793b4226